import React, { useEffect, useState } from 'react';
import { CustomDate, round  } from '../makeitwork/weather'; 
import {
    UilTemperature,
    UilTear,
    UilWind,
    UilSun,
    UilSunset,
    UilArrowUp,
    UilArrowDown,
  } from "@iconscout/react-unicons";
function Temperature({ currentFormattedData , temperatureUnit}) {
    const [iconSrc, setIconSrc] = useState(null);
    const [currentTime, setCurrentTime] = useState(CustomDate(currentFormattedData.location.tz_id));
    useEffect(() => {
    const icon = currentFormattedData.current.condition.icon.split('/').slice(-2).join('').replace('.png', '');
    const theicon = {
        night113: "falling-stars",
        night116: "partly-cloudy-night",
        night119: "overcast-night",
        night122: "overcast",
        night143: "partly-cloudy-night-fog",
        night176: "overcast-night-rain",
        night179: "overcast-night-snow",
        night182: "overcast-night-sleet",
        night185: "overcast-fog",
        night200: "thunderstorms-night-extreme",
        night227: "sleet",
        night230: "overcast-snow",
        night248: "partly-cloudy-night-fog",
        night260: "partly-cloudy-night-haze",
        night263: "overcast-night-drizzle",
        night266: "overcast-night-drizzle",
        night281: "overcast-haze",
        night284: "overcast-fog",
        night293: "overcast-night-rain",
        night296: "overcast-rain",
        night299: "overcast-night-rain",
        night302: "overcast-rain",
        night305: "overcast-night-rain",
        night308: "overcast-rain",
        night311: "overcast-haze",
        night314: "overcast-haze",
        night317: "overcast-sleet",
        night320: "overcast-sleet",
        night323: "overcast-night-sleet",
        night326: "overcast-snow",
        night329: "overcast-night-sleet",
        night332: "overcast-snow",
        night335: "overcast-night-sleet",
        night338: "overcast-snow",
        night350: "overcast-smoke",
        night353: "overcast-night-rain",
        night356: "overcast-night-rain",
        night359: "extreme-night-rain",
        night362: "overcast-night-sleet",
        night365: "overcast-night-sleet",
        night368: "overcast-snow",
        night371: "overcast-snow",
        night374: "overcast-smoke",
        night377: "overcast-smoke",
        night386: "thunderstorms-night-extreme",
        night389: "thunderstorms-extreme",
        night392: "thunderstorms-night-extreme-snow",
        night395: "thunderstorms-extreme-snow",
        //day
        day113: "clear-day",
        day116: "partly-cloudy-day",
        day119: "overcast-day",
        day122: "overcast",
        day143: "partly-cloudy-day-fog",
        day176: "overcast-day-rain",
        day179: "overcast-day-snow",
        day182: "overcast-day-sleet",
        day185: "overcast-fog",
        day200: "thunderstorms-day-extreme",
        day227: "sleet",
        day230: "overcast-snow",
        day248: "partly-cloudy-day-fog",
        day260: "partly-cloudy-day-haze",
        day263: "overcast-day-drizzle",
        day266: "overcast-day-drizzle",
        day281: "overcast-haze",
        day284: "overcast-fog",
        day293: "overcast-day-rain",
        day296: "overcast-rain",
        day299: "overcast-day-rain",
        day302: "overcast-rain",
        day305: "overcast-day-rain",
        day308: "overcast-rain",
        day311: "overcast-haze",
        day314: "overcast-haze",
        day317: "overcast-sleet",
        day320: "overcast-sleet",
        day323: "overcast-day-sleet",
        day326: "overcast-snow",
        day329: "overcast-day-sleet",
        day332: "overcast-snow",
        day335: "overcast-day-sleet",
        day338: "overcast-snow",
        day350: "overcast-smoke",
        day353: "overcast-day-rain",
        day356: "overcast-day-rain",
        day359: "extreme-day-rain",
        day362: "overcast-day-sleet",
        day365: "overcast-day-sleet",
        day368: "overcast-snow",
        day371: "overcast-snow",
        day374: "overcast-smoke",
        day377: "overcast-smoke",
        day386: "thunderstorms-day-extreme",
        day389: "thunderstorms-extreme",
        day392: "thunderstorms-day-extreme-snow",
        day395: "thunderstorms-extreme-snow",
      };  
      const iconSrc = theicon[icon];
      if (iconSrc) {
        // Dynamically import the SVG component based on the file name
        import(`../svg/${iconSrc}.svg`)
          .then((module) => setIconSrc(() => module.default))
          .catch((error) => console.error(`Failed to load SVG: ${error.message}`));
      }
    }, [currentFormattedData]);
  
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(CustomDate(currentFormattedData.location.tz_id));
        }, 900);

        return () => clearInterval(intervalId);
    }, [currentFormattedData.location.tz_id]);
  return (
    <div>
        <div>
                <div className=" flex items-center justify-center my-6" style={{ whiteSpace: 'nowrap' ,fontSize: 'clamp(1rem, 3vw, 2rem)' }}>
                    <p className="text-white font-extralight ">
                        {currentTime}
                    </p>
                </div>
                <div className=" flex items-center justify-center my-4" style={{ whiteSpace: 'nowrap' }}>
                    <p className="text-white text-2xl 2xl:text-base md:text-4xl font-mediufont-medium py-3">
                            {currentFormattedData.location.name}, 
                    </p>
                    <p className="text-white text-2xl 2xl:text-base md:text-3xl py-3 px-1" style={{ whiteSpace: 'nowrap' }}>
                        {currentFormattedData.location.country === "United States of America"  ||
                            currentFormattedData.location.country === "USA United States of America"
                            ? "USA"
                            : currentFormattedData.location.country === "United Kingdom"||
                            currentFormattedData.location.country === "UK United Kingdom"
                            ? "UK"
                            : currentFormattedData.location.country
                            }
                            
                    </p>
                </div>

            </div>
            <div  className='flex flex-col justify-center items-cente text-white'>
                <p className="text-5xl text-white flex justify-center pt-2 mb-2">{temperatureUnit === 'Celsius' ? round(currentFormattedData.current.temp_c) : round(currentFormattedData.current.temp_f)}°</p>
                <div className='flex flex-row justify-center mx-3'>
                    <div className='flex flex-row items-center justify-center'>
                            <UilArrowUp style={{ fontSize: '3vw' }}/>
                                <p className="font-light -ml-1">
                                    H:{" "}
                                    <span className="font-medium ">{temperatureUnit === 'Celsius' ? round(currentFormattedData.forecast.forecastday[0].day.maxtemp_c) : round(currentFormattedData.forecast.forecastday[0].day.maxtemp_f)}°</span>
                                </p>
                    </div>
                    <div className='flex flex-row items-center ml-2'>
                        <UilArrowDown style={{ fontSize: '3vw' }} />
                        <p className="font-light -ml-1 mr-1">
                            L:{" "}
                            <span className="font-medium ">{temperatureUnit === 'Celsius' ? round(currentFormattedData.forecast.forecastday[0].day.mintemp_c) : round(currentFormattedData.forecast.forecastday[0].day.mintemp_f) }°</span>
                        </p>
                    </div>
                </div>
            </div>
            
            <div className="flex items-center justify-center  text-xl text-white " >
                <img src={iconSrc} alt="Weather Icon" className='w-50 h-40' />
                    <p className='wx-6 font-medium text-2xl'>
                        {currentFormattedData.current.condition.text}
                    </p>
            </div>

            <div className=" flex flex-row items-center text-white py-3 pr-1 justify-center font-light text-sm sm:text-base md:text-xl">
            <div className="flex flex-row space-x-2 justify-center " style={{ whiteSpace: 'nowrap' }}>
                <div className="flex  items-center justify-center">
                    <UilTemperature  style={{ fontSize: '2vw' }} />
                        Feels like:
                    <span className="font-medium ml-1">{temperatureUnit === 'Celsius' ? round(currentFormattedData.current.feelslike_c) : round(currentFormattedData.current.feelslike_f)}°</span>
                </div>
                <p className="font-light">|</p>
                <div className="flex items-center justify-center">
                    <UilTear style={{ fontSize: '2vw' }} />
                        Humidity:
                    <span className="font-medium ml-1">{currentFormattedData.current.humidity}
                    %</span>
                </div>
                <p className="font-light">|</p>
                <div className="flex items-center justify-center">
                    <UilWind style={{ fontSize: '2vw' }}  />
                        Wind:
                    <span className="font-medium ml-1">
                        {temperatureUnit === 'Celsius' 
                            ? `${round(currentFormattedData.current.wind_kph)} kph ` 
                            : `${round(currentFormattedData.current.wind_mph)} Mph `
                        } 
                    </span>
                    
                </div>
            </div>  
        </div>
        <div className="flex flex-row items-center justify-center space-x-2 text-white text-sm sm:text-base md:text-xl py-2" style={{ whiteSpace: 'nowrap' }}>
            <div className='flex flex-row items-center'>
                <UilSun style={{ fontSize: '2vw' }} />
                <p className="font-light">
                    Rise:{" "}
                    <span className="font-medium">{currentFormattedData.forecast.forecastday[0].astro.sunrise}</span>
                </p>
            </div>
            <div className="flex items-center">
                <p className="font-light px-2">|</p>
            </div>
            <div className='flex flex-row items-center'>
                <UilSunset style={{ fontSize: '2vw' }} />
                <p className="font-light">
                    Set:{" "}
                    <span className="font-medium">{currentFormattedData.forecast.forecastday[0].astro.sunset}</span>
                </p>
            </div>
        </div>


    </div>

  )
}

export default Temperature
